import { render, staticRenderFns } from "./widgetText.vue?vue&type=template&id=222d7ee8&scoped=true&"
import script from "./widgetText.vue?vue&type=script&lang=js&"
export * from "./widgetText.vue?vue&type=script&lang=js&"
import style0 from "./widgetText.vue?vue&type=style&index=0&id=222d7ee8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d7ee8",
  null
  
)

export default component.exports